//@ts-nocheck
import xhr from "xhr";
import baseUrl from "./baseUrl";
import { withCsrfToken } from "./csrfToken";

export default {
    data() {
        return {
            requestsInProgress: 0,
        };
    },
    methods: {
        request(options, callback) {
            if (options.automaticallyRequireLogin === undefined) {
                options.automaticallyRequireLogin = true;
            }

            if (options && options.url) {
                let url = options.url;
                if (url.length > 0 && url[0] === "/") {
                    url = baseUrl.get() + url;
                }
                options.url = baseUrl.fixOldV3(url);
            }

            if (!options.headers) {
                options.headers = {};
            }
            const send = () => {
                xhr(options, (err, response) => {
                    this.requestsInProgress--;

                    if (options.automaticallyRequireLogin && response.statusCode === 401) {
                        window.location.reload();
                        return;
                    }

                    if (callback) {
                        callback(err, response);
                    }
                });
            };

            this.requestsInProgress++;

            if ((options.method || "get").toLowerCase() === "get") {
                send();
            } else {
                withCsrfToken(csrfError => {
                    if (csrfError) {
                        this.requestsInProgress--;
                        if (callback) {
                            callback(csrfError, undefined);
                        }
                        return;
                    }

                    options.headers["X-Csrf-Token"] = window.panelCsrfToken;
                    send();
                });
            }
        },
        promiseRequest(options): Promise<{ statusCode: number }> {
            return new Promise((resolve, reject) => {
                this.request(options, (err, response) => {
                    if (err) {
                        if (err.statusCode === 0) {
                            err.message = "error.no_connection";
                        }
                        return reject(err);
                    }

                    return resolve(response);
                });
            });
        },
    },
};
